import { useMutation, useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerSession } from "@/lib/query/core/invalidation";

type SellerLogoutInput = {
  storeSlug?: string;
};

export function useLogoutMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    meta: { skipGlobalErrorToast: true },
    mutationFn: async (input: SellerLogoutInput = {}) => {
      void input.storeSlug;
      return apiJsonClient<unknown>(endpoints.seller.auth.logout, {
        method: "POST",
      });
    },
    onSuccess: async (_data, variables) => {
      if (variables.storeSlug) {
        await invalidateSellerSession(queryClient, variables.storeSlug);
      }
      await queryClient.invalidateQueries({ queryKey: ["seller"] });
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
